import { render } from "./MatrixOfDomination.vue?vue&type=template&id=1237183d&scoped=true"
const script = {}

import "./MatrixOfDomination.vue?vue&type=style&index=0&id=1237183d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1237183d"]])

export default __exports__